import { api } from 'app/api'
import { useCallback, useState } from 'react'
import { ParamsPOST } from 'app/common/types/food/schools/complexes/copySort'
import { POST_COMPLEXES_COPY_SORT, convertParams, convertResult } from 'app/common/api/requests/food/schools/complexes/copy_sort/post'


export const useComplexesCopySort = () => {
  const [pending, setPending] = useState<boolean>(false)

  const submit = useCallback(async (params: ParamsPOST) => {
    setPending(true)

    const res = await api.request(POST_COMPLEXES_COPY_SORT, {
      error: 'Не удалось скопировать сортировку в другие заведения',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [])


  return {
    pending,
    submit,
  }
}
